import { Component, inject, signal } from '@angular/core';
import { LoginService } from '../../../services/login.service';

@Component({
  selector: 'app-login-modal',
  standalone: true,
  imports: [],
  templateUrl: './login-modal.component.html',
  styleUrl: './login-modal.component.scss',
})
export class LoginModalComponent {
  private login = inject(LoginService);
  readonly isOpen = this.login.isOpen;
  readonly loading = signal(false);
  readonly error = signal<string | null>(null);
  /** Który przycisk czeka — żeby napis „Logowanie…" nie pojawił się na obu. */
  readonly pending = signal<'google' | 'facebook' | null>(null);

  close() { this.login.close(); }
  stopProp(e: Event) { e.stopPropagation(); }

  signInWithGoogle() {
    return this.run('google', () => this.login.signInWithGoogle());
  }

  signInWithFacebook() {
    return this.run('facebook', () => this.login.signInWithFacebook());
  }

  private async run(which: 'google' | 'facebook', fn: () => Promise<void>) {
    this.loading.set(true);
    this.pending.set(which);
    this.error.set(null);
    try {
      await fn();
    } catch (err) {
      const msg = authErrorMessage(err);
      if (msg) this.error.set(msg);
    } finally {
      this.loading.set(false);
      this.pending.set(null);
    }
  }
}

/** `null` = nie pokazuj błędu (użytkownik sam zamknął okno logowania). */
function authErrorMessage(err: unknown): string | null {
  const code = (err as { code?: string })?.code ?? '';
  switch (code) {
    case 'auth/popup-closed-by-user':
    case 'auth/cancelled-popup-request':
    case 'auth/user-cancelled':
      return null;
    case 'auth/account-exists-with-different-credential':
      // Firebase trzyma jedno konto na adres e-mail — drugi provider z tym
      // samym mailem zostaje odrzucony, dopóki kont się nie połączy.
      return 'Na ten adres e-mail masz już konto założone innym sposobem logowania. Zaloguj się tak jak poprzednio.';
    case 'auth/popup-blocked':
      return 'Przeglądarka zablokowała okno logowania. Zezwól na wyskakujące okna i spróbuj ponownie.';
    case 'auth/operation-not-allowed':
      return 'Ten sposób logowania jest chwilowo niedostępny.';
    default:
      return 'Nie udało się zalogować. Spróbuj ponownie.';
  }
}
